import { combineReducers } from 'redux';
import ToDo from './SelectorAndTests/reducer';
import Auth from './Auth/user';
import General from './general';
import Business from './Business/business';
import platforms from './platformReducer';

export default combineReducers({
    ToDo,
    Auth,
    General,
    Business,
    platforms
});
